import _ from "lodash";

require('../../bootstrap');

import Vue          from 'vue';
import ComponentSet from "../../ComponentSet";

import utils from "../../Utils";
import moment from 'moment';
import Constants from "../../Constants";

// --------------------------------------------------------------
//                          主程式
// --------------------------------------------------------------
const app = new Vue({
    components: ComponentSet,
    mixins: [utils],
    data: {
        popShow: false,
        video: null,
        keyword: null,
        branchId: '',
        departmentId: '',
        departments: [],
    },
    created() {
        // 使用 Utils 的 method 設定
        //defaultOnCreated(this);
    },
    beforeDestroy() {

    },
    mounted() {
        let _this = this
        // 取回該頁面需要用到的資料
        this.retrieveSiteContentData(function () {
            // 將資料綁定
            _this.keyword      = _.get(_this, 'form.keyword', null) || null;
            _this.branchId     = _.get(_this, 'form.branchId', '') || '';
            
            if(_this.branchId != null){
                let allDepartments = _.get(_this, 'contentData.allDepartments', []) || [];
                _this.departments = allDepartments.filter(item => item.BranchId == _this.branchId);
            }
            _this.departmentId = _.get(_this, 'form.departmentId', '') || '';
        });
    },
    methods: {
        search(){
            let search = { keyword: '', branchId: '', departmentId: ''};
            if(this.keyword != '' && this.keyword != null){
                search.keyword = this.keyword;
            }
            if(this.branchId != '' && this.branchId != null){
                search.branchId = this.branchId;
            }
            if(this.departmentId != '' && this.departmentId != null){
                search.departmentId = this.departmentId;
            }
            window.location.search = new URLSearchParams(search).toString();
        },
        selectBranch(){
            let allDepartments = _.get(this, 'contentData.allDepartments', []) || [];
            this.departments = allDepartments.filter(item => item.BranchId == this.branchId);
        },
        openPop(data){
            this.video = data;
            this.popShow = true;
        },
        closePop(){
            this.video = null;
            this.popShow = false;
        }
    }, // end of methods
    computed: {
        serverRoot() {
            return Constants.serverRoot
        },
        listData() {
            
            let data = _.get(this, 'contentData.list', []) || [];
            return _.chunk(data, 3);
        },
        branches() {
            return _.get(this, 'contentData.branches', []) || [];
        }
    }, // end of computed
}).$mount('#app');